import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Jan 30 2019
 * @author LZe
 */
import * as React from 'react';
import Button, { ButtonColor, ButtonSize } from '../../../controls/Button';
import translate from '../../../i18n/translate';
import Icon, { IconColor, IconType } from '../../../media/Icon';
import Tooltip from '../../../info/Tooltip';

var ResetAll =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ResetAll, _React$PureComponent);

  function ResetAll() {
    var _this;

    _classCallCheck(this, ResetAll);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResetAll).apply(this, arguments));

    _this.resetAll = function (event) {
      setTimeout(function () {
        var activeFilters = _this.props.api.getFilterModel();

        Object.keys(activeFilters).forEach(function (key) {
          _this.props.api.destroyFilter(key);
        });

        _this.props.api.setSortModel(null);
      }, 1);
    };

    return _this;
  }

  _createClass(ResetAll, [{
    key: "render",
    value: function render() {
      return React.createElement(Tooltip, {
        overlay: React.createElement("div", null, translate('RESET_FILTERS')),
        children: React.createElement("div", {
          style: {
            padding: '10px 0'
          }
        }, React.createElement(Button, {
          onClick: this.resetAll,
          buttonColor: ButtonColor.Light,
          buttonSize: ButtonSize.Tiny,
          iconButton: true
        }, React.createElement(Icon, {
          iconType: IconType.filterCancel,
          iconColor: IconColor.Secondary
        }))),
        placement: "top"
      });
    }
  }]);

  return ResetAll;
}(React.PureComponent);

export { ResetAll as default };